import { resolveImageSourceUrl, type Image as DynamicImageRecord } from '@/lib/images/dynamic-image';
import type { Image } from '@/types';

type ViewportImageSource = string | Image | DynamicImageRecord | null | undefined;

/** Normalizes a Page Designer / SCAPI image to a comparable URL string. */
export function resolveImageAssetKey(image?: ViewportImageSource): string | undefined {
    if (!image) {
        return undefined;
    }

    if (typeof image === 'string') {
        const trimmed = image.trim();
        return trimmed || undefined;
    }

    return resolveImageSourceUrl(undefined, image as DynamicImageRecord)?.trim() || undefined;
}

/** True when a dedicated mobile asset is authored and differs from the desktop asset. */
export function hasDistinctViewportImages(desktop?: ViewportImageSource, mobile?: ViewportImageSource): boolean {
    const mobileKey = resolveImageAssetKey(mobile);
    if (!mobileKey) {
        return false;
    }

    return resolveImageAssetKey(desktop) !== mobileKey;
}
